import React, { useEffect, useState } from "react";
import "./index.less";
import { Col, Empty, Row } from "antd";

function DashboardData(props) {
  const { data } = props;
  console.log(data, "指标卡数据");
  const [initData, setInitData] = useState(data);
  const { data: Ddata, dim_field, metric_fields } = initData;
  useEffect(() => {
    setInitData(data);
  }, [data]);
  return (
    <div className="zbk">
      <Row>
        {Ddata && Ddata.length ? (
          <>
            {Ddata.map((item) => {
              return (
                <Col span={24 / Ddata.length}>
                  <div className="item">
                    {item.map((jtem) => {
                      return (
                        <div>
                          {typeof jtem === "number" ? (
                            <>
                              <span>{jtem.toLocaleString()}</span>
                              <span style={{
                                fontSize:"16px",
                                color:"#aaa",
                                paddingLeft:"5px"
                              }}>{metric_fields?.[0]?.unit || ""}</span>
                            </>
                          ) : (
                            jtem
                          )}
                        </div>
                      );
                    })}
                  </div>
                </Col>
              );
            })}
          </>
        ) : (
          <Empty />
        )}
      </Row>
    </div>
  );
}

export default DashboardData;
